import { useParams } from 'react-router';

import { getQuizExtensionBuilderSet } from '@/lib/tiptap-extensions-sets';

export function useGetQuizTiptapExtensionBuilderSet() {
  const { quizId } = useParams();

  return getQuizExtensionBuilderSet(quizId);
}
